import axios, { AxiosResponse } from "axios";
import { getStandardServerError, RequestSender } from "./helpers";
import { ExternalLoginResponse } from "./model";

function isStudentClassNotPermittedResponse(response: AxiosResponse) {
  if (response.status !== 403) {
    return false;
  }
  try {
    const body = response.data;
    return (
      typeof body === "object" &&
      !!body &&
      (body as Record<string, unknown>).message ===
        "Student class not permitted"
    );
  } catch (e) {
    return false;
  }
}

const studentClassNotPermittedErrorMessage =
  "No permitted class found for student";

function isStudentClassNotPermittedError(error: unknown) {
  return (
    typeof error === "object" &&
    !!error &&
    error.constructor === Error &&
    (error as Error).message === studentClassNotPermittedErrorMessage
  );
}

async function loginClever(
  request: RequestSender,
  code: string,
  redirectUri: string,
): Promise<ExternalLoginResponse> {
  try {
    const response = await request<any>("post", "/auth/login/clever", {
      code,
      redirectUri,
    });
    return {
      id: response.data.data.id,
      username: response.data.data.sUserName,
      userType: response.data.data.eUserType,
      loginType: {
        type: response.data.data.oLoginType.eType,
      },
      authToken: response.headers.authorization,
    };
  } catch (e) {
    if (
      axios.isAxiosError(e) &&
      e.response &&
      isStudentClassNotPermittedResponse(e.response)
    ) {
      throw new Error(studentClassNotPermittedErrorMessage);
    }

    const message = getStandardServerError(e);
    if (message) {
      throw new Error(message);
    }
    throw e;
  }
}

export { isStudentClassNotPermittedError };
export default loginClever;
